import React, { useRef, useState} from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function RishikeshBanner({bannerImages, buttonLink}) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        speed: 2400,
        autoplaySpeed: 3500,
        draggable: false,
        swipe: false,
        centerMode: true,
        centerPadding: '0',
        responsive: [
        {
            breakpoint: 767,
            settings: { slidesToShow: 3, },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 3 ,},
        },
        ],
    };

    const settings2 = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 2400,
        autoplaySpeed: 3500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,
        swipe: false,
    };

  return (
    <>
    <div className="resort-banner">
        <div className="mainbanner-slider">
            <Slider {...settings2}>
                {bannerImages.map((item, index) => (
                  <img src={item.img} className="img-responsive" alt="banner" key={index}/>
                ))}
            </Slider>
        </div>

        <div className="container smallbanner-slider">
            <div className="row justify-content-end">  
                <div className="col-lg-4 col-md-5 col-sm-6">
                    <Slider {...settings}>
                      {bannerImages.map((item, index) => (
                        <img src={item.img} className="img-responsive" alt="banner" key={index}/>
                      ))}
                    </Slider>
                </div>
            </div>
        </div>

        <div className="mainbanner-form">
          <div className="container">
              <div className="row">  
                  <div className="col-lg-12">
                    <form>
                        <div className="form-datebox">
                            <div className="datefeild">
                              <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                minDate={new Date()}
                                placeholderText="Check-In"
                                dateFormat="dd/MM/yyyy"
                              />
                              <Icons name="arrowDown" />
                            </div>

                            <div className="datefeild">
                              <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                minDate={startDate || new Date()}
                                placeholderText="Check-Out"
                                dateFormat="dd/MM/yyyy"
                              />
                              <Icons name="arrowDown" />
                            </div>
                        </div>

                        <div className="form-butnbox">
                          <button onClick={() => window.open(buttonLink, "_blank")} className="">Check Availability</button>
                        </div>
                    </form>
                  </div>
              </div>
          </div>
        </div>

    </div> 
    </>
  )
}
